import { addMessages, init, _, getLocaleFromNavigator, locale } from 'svelte-i18n';

import sv from '../public/locale/sv.json';
import en from '../public/locale/en.json';

const fallbackLocale = 'sv';
const lngs = [fallbackLocale, 'en'];

addMessages('sv', sv);
addMessages('en', en);

locale.subscribe((lng) => {
  if (lng) localStorage.setItem('svelte-i18n-locale', lng);
});

let initialLocale;
const detectedLocale = localStorage.getItem('svelte-i18n-locale') || getLocaleFromNavigator(); // the locale could be region specific, i.e. sv-SE
if (lngs.indexOf(detectedLocale) > -1) initialLocale = detectedLocale; //sets initialLocale to detectedLocale only if detectedLocale is among the supported languages
if (!initialLocale && detectedLocale.indexOf('-') > 0) {
  const foundLng = lngs.find((l) => detectedLocale.indexOf(l + '-') === 0);
  if (foundLng) initialLocale = foundLng;
}
if (!initialLocale) initialLocale = fallbackLocale;

init({
  fallbackLocale,
  initialLocale
});